import { NotificationsWrapperProps } from '@customTypes/PropTypes';
import GeneralNotification from '@landing/GeneralNotification/GeneralNotification';
import Notification from '@shared/Notification/Notification';
import { useState } from 'react';
import { NOTIFICATION_ORDER } from './constants';

const NotificationsWrapper = ({ otherNotifications, pageId }: NotificationsWrapperProps)
    : JSX.Element => {
    const [dashboardNotifications, setDashboardNotifications] = useState(otherNotifications.sort((a, b) => NOTIFICATION_ORDER[a.type] - NOTIFICATION_ORDER[b.type]));

    const hideNotification = (key: string) => {
        sessionStorage.setItem(`Notification_${key}`, key);
        setDashboardNotifications((dashboardNotifications) => dashboardNotifications.map((notification) => (notification.key === key
            ? { ...notification, hidden: true }
            : notification)));
    };
    return (
        <>
            {/* Notifications with external logic or text only */}
            {dashboardNotifications.length > 0
                && dashboardNotifications.map((notification) => (
                    <Notification key={notification.key}>
                        {!notification.hidden && !sessionStorage.getItem(`Notification_${notification.key}`)
                            ? (
                                <GeneralNotification
                                    message={notification.message}
                                    type={notification.type}
                                    bold={notification.bold as boolean}
                                    iconType={notification.iconType ?? 'circle'}
                                    cta={notification.cta}
                                    ctaLearn={notification.ctaLearn}
                                    closeButton={notification.closeButton}
                                    closeHandler={() => hideNotification(notification.key)}
                                />
                            ) : <></>}
                    </Notification>
                ))}

        </>
    );
};

export default NotificationsWrapper;
